import React, { useState } from 'react';
import { Soup, Flame, Package, Sparkles } from 'lucide-react';
import AnimatedIntroCarousel from '../../widgets/AnimatedIntroCarousel';
import Carousel from '../../widgets/Carousel';
import EntryForm from '../../widgets/EntryForm';
import Header from '../../widgets/Header';
import Footer from '../../widgets/Footer';
import { useBrandConfig } from '../../../context/BrandConfigContext';
import '../noodles.css';

const INTRO_SEEN_KEY = 'noodles_intro_seen';

// Placeholder-graphic flavor slides — swap `icon`/pack labels for real photography once supplied.
const INTRO_SLIDES = [
  {
    id: 'goreng',
    background: 'linear-gradient(160deg, #e2001a 0%, #b8000f 100%)',
    render: () => (
      <>
        <div className="intro-slide-plate">
          <Soup size={72} color="#e2001a" />
        </div>
        <h2 className="intro-slide-title">Recipe Ideas to Goreng</h2>
        <p className="intro-slide-subtitle">Original Mi Goreng</p>
        <div className="intro-slide-pack">
          <Package size={28} color="#e2001a" />
          <span className="intro-slide-pack-label">Mi Goreng</span>
        </div>
      </>
    )
  },
  {
    id: 'jer',
    background: 'linear-gradient(160deg, #ffc20e 0%, #f2a900 100%)',
    render: () => (
      <>
        <h2 className="intro-slide-title">Goreng Jer Dengan</h2>
        <p className="intro-slide-subtitle">Always the perfect fit</p>
        <div className="intro-slide-pack">
          <Package size={28} color="#b8000f" />
          <span className="intro-slide-pack-label">Mi Goreng</span>
        </div>
      </>
    )
  },
  {
    id: 'sambal-udang',
    background: 'linear-gradient(160deg, #3f8f3a 0%, #2b6626 100%)',
    render: () => (
      <>
        <div className="intro-slide-plate">
          <Flame size={72} color="#3f8f3a" />
        </div>
        <h2 className="intro-slide-title">Sambal Udang</h2>
        <p className="intro-slide-subtitle">Spicy prawn sambal</p>
        <div className="intro-slide-pack">
          <Package size={28} color="#2b6626" />
          <span className="intro-slide-pack-label">Sambal Udang</span>
        </div>
      </>
    )
  },
  {
    id: 'semua-pasti-suka',
    background: 'linear-gradient(160deg, #e2001a 0%, #b8000f 100%)',
    render: () => (
      <>
        <div className="intro-slide-pack-row">
          <div className="intro-slide-pack">
            <Package size={22} color="#e2001a" />
            <span className="intro-slide-pack-label">Original</span>
          </div>
          <div className="intro-slide-pack">
            <Package size={22} color="#2b6626" />
            <span className="intro-slide-pack-label">Sambal</span>
          </div>
          <div className="intro-slide-pack">
            <Package size={22} color="#b8000f" />
            <span className="intro-slide-pack-label">Kari</span>
          </div>
        </div>
        <h2 className="intro-slide-title">Semua Pasti Suka</h2>
        <p className="intro-slide-subtitle">
          <Sparkles size={14} style={{ marginRight: 4, verticalAlign: 'text-bottom' }} />
          Everyone will love it
        </p>
      </>
    )
  }
];

// First visit: full-screen animated flavor showcase, then the standard code-entry page.
const Entry = () => {
  const brand = useBrandConfig();
  const logoSrc = brand?.logoUrl || '/assets/images/app-logo/coca-cola-white.png';
  const [showIntro, setShowIntro] = useState(() => {
    try {
      return !localStorage.getItem(INTRO_SEEN_KEY);
    } catch {
      return true;
    }
  });

  const handleIntroComplete = () => {
    try {
      localStorage.setItem(INTRO_SEEN_KEY, '1');
    } catch {
      /* private-browsing / storage disabled — just skip the intro this time */
    }
    setShowIntro(false);
  };

  if (showIntro) {
    return <AnimatedIntroCarousel slides={INTRO_SLIDES} onComplete={handleIntroComplete} />;
  }

  return (
    <div className="noodles-theme">
      <Header title="" showBack={false} rightContent={<img src={logoSrc} width={90} alt="App Logo" />} />

      <main className="page-content strict-width">
        <div className="noodles-entry-hero text-center">
          <h1>Noodles Exclusive</h1>
          <p>Enter your code for a chance to win</p>
        </div>

        <Carousel />

        <div className="container strict-width">
          <EntryForm />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Entry;
